import * as React from "react";
import type { Category } from "../../../../server/results";
import type { EntryType } from "../CompoPage";
import type { User } from "../../models/users";
import { ResultColumn } from "./ResultColumn";

export type ResultColumnsProps = {
  categoryNames: string[];
  type: EntryType;
  categories: Category[];
  entryUsers: { [entry_id: number]: User[] };
};

const DEFAULT_INDEXES = [0, 1, 2, 3, 4, 5, 6, 7, 8];
const DISPLAY_LIMIT = 7;

export const ResultColumns = ({
  categoryNames,
  entryUsers,
  categories,
  type,
}: ResultColumnsProps): JSX.Element => {
  return (
    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
      {DEFAULT_INDEXES.map((index) => {
        if (!categoryNames[index]) {
          return undefined;
        }

        return (
          <ResultColumn
            key={`${type}-${categoryNames[index]}`}
            categoryName={categoryNames[index]}
            entries={categories[index]}
            linkToFullResults={`results/${type}/${index}`}
            limit={DISPLAY_LIMIT}
            entryUsers={entryUsers}
            fullWidth={false}
          />
        );
      })}
    </div>
  );
};